import LogoMark from "./LogoMark";

type WordmarkProps = {
  /** "light" = text colours for light surfaces, "dark" = for dark surfaces. */
  tone?: "light" | "dark";
  size?: number;
};

/** Logo mark + "Infinitude Stack" set in the display font. */
const Wordmark = ({ tone = "light", size = 20 }: WordmarkProps) => {
  return (
    <span
      className={"is-wordmark" + (tone === "dark" ? " is-wordmark--dark" : "")}
      style={{ fontSize: size }}
    >
      <LogoMark size={size * 1.8} stroke="currentColor" />
      <span className="is-wordmark__text">
        <span className="is-wordmark__strong">Infinitude</span>{" "}
        <span className="is-wordmark__soft">Stack</span>
      </span>
    </span>
  );
};

export default Wordmark;
